import {
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Dialog from "@material-ui/core/Dialog";
import http from "../services/httpService";
import PdfAua from "./pdfAua";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { TableRow } from "@mui/material";
import SearchBar from "material-ui-search-bar";
import { getDate, getDateTime, searchFilter } from "../utils/varialbles";

function Aua() {
  const fields = [
    {
      id: 0,
      label: "Date",
      type: "date",
      key: "proposal_dt",
      required: true,
    },
    {
      id: 1,
      label: "PIAS ID",
      type: "text",
      key: "pias_id",
      required: true,
    },
    {
      id: 2,
      label: "Prospect Name",
      type: "text",
      key: "name",
      required: true,
    },
    {
      id: 3,
      label: "Service Type",
      type: "dropdown",
      key: "service_type",
      required: true,
      options: [
        { name: "PMS" },
        { name: "Personal Finance" },
        { name: "Investment Advisory" },
      ],
    },
    {
      id: 4,
      label: "Account Type",
      type: "dropdown",
      key: "account_type",
      required: true,
      options: [
        { name: "Individual" },
        { name: "Joint Account" },
        { name: "HUF" },
        { name: "Corporate" },
      ],
    },
    {
      id: 5,
      label: "Investment Amount",
      child: [
        {
          label: "Initial Amount",
          type: "numtext",
          key: "intitial_amt",
          required: true,
        },
        {
          label: "Investment",
          type: "dropdown",
          key: "investment",
          required: true,
          childOptions: [{ name: "Fresh" }, { name: "Existing" }],
        },
        {
          label: "Reoccuring Amount",
          type: "text",
          key: "recurring_amt",
          required: true,
        },
        { label: "Frequency", type: "text", key: "frequency", required: true },
      ],
    },
    {
      id: 6,
      label: "Savart+",
      child: [
        {
          label: "Maintenance fee on capital investment",
          type: "text",
          key: "maintainance_fee",
          required: true,
        },
        {
          label: "Profit Sharing",
          type: "text",
          key: "profit_share",
          required: true,
        },
        {
          label: "Hurdale Rate",
          type: "text",
          key: "hurdle_rate",
          required: true,
        },
        {
          label: "Privilege Customer Offer",
          type: "text",
          key: "cust_offer",
          required: true,
        },
      ],
    },
    {
      id: 7,
      label: "Valid Till",
      type: "date",
      key: "valid_till",
      required: true,
    },
  ];

  const [form, setForm] = useState({
    pias_id: "",
    name: "",
    service_type: "",
    account_type: "",
    currency: "",
    intitial_amt: "",
    investment: "",
    recurring_amt: "",
    frequency: "",
    maintainance_fee: "",
    profit_share: "",
    hurdle_rate: "",
    cust_offer: "",
    proposal_dt: "",
    valid_till: "",
  });
  const [pdfurl, setpdfurl] = useState("");
  const [open, setOpen] = useState(false);
  const [generateButton, setGenerateButton] = useState(true);
  // const [countLength, setCountLength] = useState(0);
  let count = 5;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (form["cust_offer"].length >= 62) {
      toast.error("Privillage Customer Offer should not be greater then 62");
    }    
  };

  // console.log(form["cust_offer"].length);

  // console.log(form);

  const validations = (obj) => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          return false;
        }
      }
    }

    return true;
  };

  const submit = () => {
    console.log(form);
    if (validations(form)) {
      if (form["intitial_amt"] && isNaN(form["intitial_amt"])) {
        toast.error("please enter only numbers for Initial amount");
      } else if (form["maintainance_fee"] && isNaN(form["maintainance_fee"])) {
        toast.error("please enter only numbers for Maintainence fee");
      } else if (
        form["maintainance_fee"] < 0 ||
        form["maintainance_fee"] > 100
      ) {
        toast.error(
          "please enter only numbers for Maintainence fee of valid percentage value"
        );
      } else if (form["cust_offer"].length > 62) {
        toast.error("Privillage Customer Offer should not be greater then 62");
      } else {
        http
          .post("/aua_data", form)
          .then((response) => {
            // console.log(response);
            if (response.data.statusCode === 0) {
              toast.success("PDF Generated");
              setpdfurl(response.data.Data);
              setGenerateButton(false);
              setForm({ ...form, id: response.data.id });
            } else {
              toast.error(response.data.Data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      toast.error("please fill all the fields");
    }
  };

  const update = () => {
    console.log(form, "updateform");

    if (validations(form)) {
      if (form["intitial_amt"] && isNaN(form["intitial_amt"])) {
        toast.error("please enter only numbers for Initial amount");
      } else if (form["maintainance_fee"] && isNaN(form["maintainance_fee"])) {
        toast.error("please enter only numbers for Maintainence fee");
      } else if (
        form["maintainance_fee"] < 0 ||
        form["maintainance_fee"] > 100
      ) {
        toast.error(
          "please enter only numbers for Maintainence fee of valid percentage value"
        );
      } else if (form["cust_offer"].length > 62) {
        toast.error("Privillage Customer Offer should not be greater then 62");
      } else {
        http
          .post("/aua_data", form)
          .then((response) => {
            // console.log(response);
            if (response.data.statusCode === 0) {
              toast.success("PDF Generated");
              setpdfurl(response.data.Data);
              // setForm({ ...form, id: response.data.id });
              // setGenerateButton(false);
            } else {
              toast.error(response.data.Data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      toast.error("please fill all the fields");
    }
  };

  const [getTab, setTab] = useState(0);

  const tableCols = [
    {
      id: "exe_name",
      label: "Executive Name",
      minWidth: 150,
    },
    {
      id: "proposal_dt",
      label: "Proposal Date",
      type: "date",
      minWidth: 150,
    },
    {
      id: "pias_id",
      label: "Paisa Id",
      minWidth: 150,
    },
    {
      id: "name",
      label: "Prospect Name",
      minWidth: 150,
    },
    {
      id: "service_type",
      label: "Service Type",
      minWidth: 150,
    },
    {
      id: "account_type",
      label: "Account Type",
      minWidth: 150,
    },
    {
      id: "currency",
      label: "Currency",
      minWidth: 150,
    },
    {
      id: "intitial_amt",
      label: "Initial Amount",
      minWidth: 150,
    },
    {
      id: "investment",
      label: "Investment",
      minWidth: 150,
    },
    {
      id: "recurring_amt",
      label: "Reoccuring Amount",
      minWidth: 150,
    },
    {
      id: "frequency",
      label: "Frequency",
      minWidth: 150,
    },
    {
      id: "maintainance_fee",
      label: "Maintenance Fee",
      minWidth: 150,
    },
    {
      id: "profit_share",
      label: "Profit Share",
      minWidth: 150,
    },
    {
      id: "cust_offer",
      label: "Privillege Customer offer",
      minWidth: 150,
    },
    {
      id: "hurdle_rate",
      label: "Hurdle Rate",
      minWidth: 150,
    },
    {
      id: "valid_till",
      label: "Valid Till",
      type: "date",
      minWidth: 150,
    },
    {
      id: "",
      label: "",
      button: true,
    },
  ];

  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRowsRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRowCount, setTotalRowCount] = useState("");
  const [searched, setSearched] = React.useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...originalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const [getbaseURL, setbaseURL] = useState("");

  useEffect(() => {
    http
      .get(getPaginationURL("/aua_data"))
      .then((res) => {
        console.log(res.config.baseURL);
        if (res.data.statusCode === 0) {
          setbaseURL(res.config.baseURL);
          setRows(res.data.Data);
          setOriginalRowsRows(res.data.Data);
          setTotalRowCount(res.data.Data.length);
        } else {
          setRows([]);
          setOriginalRowsRows([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const openPdf = (e, row) => {
    console.log(row.file);
    window.open(
      getbaseURL.replace("workflow/", "") + "media/" + row.file,
      "_blank"
    );
    // console.log(getbaseURL.replace("workflow/", "") + "/media/" + row.file);
  };

  return (
    <div style={{ padding: "0px 0 20px 0" }}>
      <div style={{ display: "flex", columnGap: 30 }}>
        <button
          onClick={(e) => setTab(0)}
          style={{
            backgroundColor: getTab === 0 ? "#2835d5" : "transparent",
            padding: "5px 20px",
            borderRadius: 20,
            border: "transparent",
            cursor: "pointer",
            color: getTab === 0 ? "#fff" : "#000",
          }}
          value={0}
        >
          Proposal
        </button>
        <button
          onClick={(e) => setTab(1)}
          style={{
            backgroundColor: getTab === 1 ? "#2835d5" : "transparent",
            padding: "5px 20px",
            borderRadius: 20,
            border: "transparent",
            cursor: "pointer",
            color: getTab === 1 ? "#fff" : "#000",
          }}
          value={1}
        >
          Report
        </button>
      </div>

      <h2>
        {getTab === 0 && form["service_type"]
          ? form["service_type"] + " " + "Proposal"
          : ""}
      </h2>

      {getTab === 0 &&
        fields.map((item, index) => {
          return (
            <div className="aua">
              <div style={{ display: "flex", margin: "10px 0" }}>
                <label style={{ width: "25%", fontWeight: "bold" }}>
                  {item.label}{" "}
                  {item.required === true && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </label>
                {item.type === "text" ? (
                  <input type="text" name={item.key} onChange={handleChange} />
                ) : item.type === "date" ? (
                  <input type="date" name={item.key} onChange={handleChange} />
                ) : item.type === "dropdown" ? (
                  <select name={item.key} onChange={handleChange}>
                    <option value="">Select</option>
                    {item.options.map((opt, inndex) => {
                      return <option value={opt.name}>{opt.name}</option>;
                    })}
                  </select>
                ) : (
                  ""
                )}
              </div>
              {item.child &&
                item.child.map((childItem, index) => {
                  return (
                    <div style={{ display: "flex", margin: "10px 0" }}>
                      <label style={{ width: "25%" }}>
                        {childItem.label}{" "}
                        {childItem.required === true && (
                          <span style={{ color: "red", fontWeight: "bold" }}>
                            *
                          </span>
                        )}
                      </label>
                      {childItem.type === "text" ? (
                        <>
                          <input
                            type="text"
                            name={childItem.key}
                            onChange={handleChange}
                          />

                          <p>
                            {childItem.key === "cust_offer"
                              ? form["cust_offer"].length + "/" + 62
                              : ""}
                          </p>
                        </>
                      ) : childItem.type === "numtext" ? (
                        <>
                          <select
                            style={{ width: 46, marginRight: 5, height: 33 }}
                            name="currency"
                            onChange={handleChange}
                          >
                            <option select="">currency</option>
                            <option value="INR">&#8377; </option>
                            <option value="ISD">&#36; </option>
                          </select>{" "}
                          <input
                            type="text"
                            name={childItem.key}
                            onChange={handleChange}
                            style={{ width: 194 }}
                          />
                        </>
                      ) : childItem.type === "dropdown" ? (
                        <select name={childItem.key} onChange={handleChange}>
                          <option value="">Select</option>
                          {childItem.childOptions.map((childOpt, index) => {
                            return (
                              <option value={childOpt.name}>
                                {childOpt.name}
                              </option>
                            );
                          })}
                        </select>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
            </div>
          );
        })}

      {generateButton === true && getTab === 0 ? (
        <Button color="primary" variant="contained" onClick={submit}>
          Generate
        </Button>
      ) : (
        ""
      )}

      {pdfurl.length > 0 ? (
        <Button
          color="primary"
          variant="contained"
          style={{ marginInline: 5 }}
          onClick={() => setOpen(true)}
        >
          Preview
        </Button>
      ) : (
        ""
      )}

      {generateButton === false ? (
        <Button color="primary" variant="contained" onClick={update}>
          Update PDF
        </Button>
      ) : (
        ""
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="draggable-dialog-title"
        // style={{ height: "500px" }}
      >
        <DialogContent>
          <PdfAua pdfurl={pdfurl} />
        </DialogContent>

        <DialogActions>
          <a href={pdfurl} target="_blank" rel="noreferrer" download>
            <Button color="primary" variant="contained">
              Download
            </Button>
          </a>
        </DialogActions>
      </Dialog>

      {getTab === 1 && (
        <div>
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            className={"mt30"}
          />
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 1500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <TableContainer>
            <TableHead>
              <TableRow>
                {tableCols.map((item, index) => {
                  return (
                    <TableCell style={{ width: item.minWidth }}>
                      {item.label}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow>
                      {tableCols.map((cols, index) => {
                        const value = row[cols.id];
                        return (
                          <TableCell style={{ width: cols.minWidth }}>
                            {cols.type === "date" ? (
                              getDate(value)
                            ) : cols.button === true ? (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={(e) => openPdf(e, row)}
                              >
                                Download
                              </Button>
                            ) : value ? (
                              value
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </TableContainer>
        </div>
      )}
    </div>
  );
}

export default Aua;
